import React, { Fragment } from 'react';


const About = (props) => {
  return (
    <Fragment>
      <h1 className='center'>About Page </h1>
      <p style={{fontSize: '2rem' }}>
      ثُمَّ أَنتُمۡ هَٰٓؤُلَآءِ تَقۡتُلُونَ أَنفُسَكُمۡ وَتُخۡرِجُونَ فَرِيقٗا مِّنكُم مِّن دِيَٰرِهِمۡ تَظَٰهَرُونَ عَلَيۡهِم بِٱلۡإِثۡمِ وَٱلۡعُدۡوَٰنِ وَإِن يَأۡتُوكُمۡ أُسَٰرَىٰ تُفَٰدُوهُمۡ وَهُوَ مُحَرَّمٌ عَلَيۡكُمۡ إِخۡرَاجُهُمۡۚ أَفَتُؤۡمِنُونَ بِبَعۡضِ ٱلۡكِتَٰبِ وَتَكۡفُرُونَ بِبَعۡضٖۚ فَمَا جَزَآءُ مَن يَفۡعَلُ ذَٰلِكَ مِنكُمۡ إِلَّا خِزۡيٞ فِي ٱلۡحَيَوٰةِ ٱلدُّنۡيَاۖ وَيَوۡمَ ٱلۡقِيَٰمَةِ يُرَدُّونَ إِلَىٰٓ أَشَدِّ ٱلۡعَذَابِۗ وَمَا ٱللَّهُ بِغَٰفِلٍ عَمَّا تَعۡمَلُونَ
</p>
<p>
(Muhsin Khan and Taqi-ud-Din al-Hilali)<br />
After this, it is you who kill one another and drive out a party of you from their homes, assist (their enemies) against them, in sin and transgression. And if they come to you as captives, you ransom them, although their expulsion was forbidden to you. Then do you believe in a part of the Scripture and reject the rest? Then what is the recompense of those who do so among you, except disgrace in the life of this world, and on the Day of Resurrection they shall be consigned to the most grievous torment. And Allah is not unaware of what you do.</p>

<p>
(Sahih International)<br />
Then, you are those [same ones who are] killing one another and evicting a party of your people from their homes, cooperating against them in sin and aggression. And if they come to you as captives, you ransom them, although their eviction was forbidden to you. So do you believe in part of the Scripture and disbelieve in part? Then what is the recompense for those who do that among you except disgrace in worldly life; and on the Day of Resurrection they will be sent back to the severest of punishment. And Allah is not unaware of what you do.

<br /><strong className='right my'>- Sura Al-Baqarah, Ayah 85</strong>
      </p>
    </Fragment>
  ) 
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js